import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { initApp } from '@adornis/functional-lit/init-app.js';
import { authenticationGuard } from '@adornis/user-forms/authentication-guard.js';
import { functionalLogin } from '@adornis/user-forms/function-login.js';
import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { isPublicRoute } from '@ndi/sdr-ui/public-routes.js';
import { sdrRouter } from '@ndi/sdr-ui/sdr-router.js';
import { html } from 'lit';
import '../db/index.js';
import './tailwind.css' with { type: 'tailwind' };

BaseQLClient.initDefault();
subscribeCurrentUser();

const loginTemplate = () =>
  html`<div class="ndi-gradient flex min-h-screen items-center justify-center">
    <div class="card bg-base-100 ndi-auth-card w-full max-w-sm shadow-xl">
      <div class="card-body">
        <div class="mb-4 flex flex-col items-center">
          <span class="ndi-logo-text text-5xl">NDI</span>
          <span class="text-base-content/50 mt-1 text-xs font-medium tracking-widest uppercase"
            >New Digital Intelligence</span
          >
        </div>
        <h2 class="card-title mb-2 justify-center text-lg font-semibold">AI SDR Login</h2>
        ${functionalLogin({
          placeholderUsername: 'Username or Email',
          placeholderPassword: 'Password',
        })}
      </div>
    </div>
  </div>`;

const router = sdrRouter.init();

void initApp(() => {
  const outlet = router.outlet.value;
  const currentRoute = sdrRouter.currentRoute.value.route.name;

  // Which routes are public is decided in one place, with a reason recorded per
  // route (`@ndi/sdr-ui/public-routes.js`). It lived here as an inline chain
  // that nothing could reach, and `optOut` was missing from it — so the
  // unsubscribe link in every outbound email landed a prospect on a login form.
  if (isPublicRoute(currentRoute)) {
    return html`${outlet}`;
  }

  return html`${authenticationGuard(() => html`${outlet}`, loginTemplate)}`;
});
